import React, { useEffect, useState } from "react";
import { firestore } from "../../config/firebase";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Star } from "@mui/icons-material";
import { colors } from "../../utils/color";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import "./session.css";
import "../../componets/style.css";
import { DatePicker } from "antd";
import CounsellorProfile from "./counsellorProfile";
export default function SessionsLogs({
  logs,
  handle_filter,
  activeTab,
  toggle_filter,
  showFilter,
  dummy,
  handleDateFilter,
  logList,
}) {
  const { RangePicker } = DatePicker;
  return (
    <div>
      {dummy?.length > 0 && (
        <div className="filter-container">
          {(activeTab == "3" || activeTab == "4") && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <img src="/slider.svg" onClick={toggle_filter} alt="Filter" />
              {(logs.length !== dummy.length && activeTab == "3") ||
              (logList?.length !== dummy?.length && activeTab == "4") ? (
                <span
                  className="clear-filter"
                  onClick={() => handle_filter("4")}
                >
                  Clear Filter
                </span>
              ) : (
                <></>
              )}
            </div>
          )}

          {(activeTab == "3" || activeTab == "4") && showFilter && (
            <div className="filter-modal">
              <div className="filter-sub-modal">
                <span onClick={() => handle_filter("1")}>Voice Call</span>
                <span onClick={() => handle_filter("2")}>Video Call</span>
                {activeTab == "3" && (
                  <span onClick={() => handle_filter("3")}>Chat</span>
                )}
              </div>
              <CloseIcon className="close-icon" onClick={toggle_filter} />
            </div>
          )}

          <div
            style={{
              position: "absolute",
              left: "160px",
              paddingBottom: "10px",
            }}
          >
            <RangePicker onChange={handleDateFilter} />
          </div>
        </div>
      )}

      <Grid spacing={0} width={"50%"} style={{ marginTop: "20px" }}>
        {logs?.map((item, index) => {
          return (
            <>
              <div style={{ display: "flex" }}>
                <div>
                  <img
                    src={"/stu.jpg"}
                    style={{ width: 150, height: "100%", background: "red" }}
                  />
                </div>

                <div style={{ paddingLeft: 10 }}>
                  <div>
                    <span style={{ fontSize: 18, fontWeight: 500 }}>
                      {item.counsellor_name}
                    </span>
                    <div className="parent">
                      <div>
                        <div className="log_container">
                          <span className="log_detail">{"Start Time"}</span>
                          <span className="log_detail">
                            {moment(item.start_time).format("LT")}
                          </span>
                        </div>
                        <div className="log_container">
                          <span className="log_detail">{"End Time"}</span>
                          <span className="log_detail">
                            {moment(item.end_time).format("LT")}
                          </span>
                        </div>
                      </div>
                      <div>
                        <div className="log_container">
                          <span className="log_detail">{"Type"}</span>
                          <span className="log_detail">{item.type}</span>
                        </div>
                        <div className="log_container">
                          <span className="log_detail">{"  "}</span>
                          <span className="log_detail">{"  "}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {item.type == "chat" && (
                    <span className="chat_link">View Chat History</span>
                  )}
                </div>
              </div>
              <div className="divider" />
            </>
          );
        })}
      </Grid>
    </div>

    // <div className="call-log-container">
    //   {logs.map((log, index) => (
    //     <div key={index} className="call-log-item">
    //       <img
    //         src={log.image}
    //         alt={log.callerName}
    //         className="call-log-image"
    //       />
    //       <div className="call-log-details">
    //         <h3 className="caller-name">{log.callerName}</h3>
    //         <p className="call-time">{log.callTime}</p>
    //         <p className="call-duration">{log.callDuration}</p>
    //         <p className="call-type">{log.callType}</p>
    //       </div>
    //     </div>
    //   ))}
    // </div>
  );
}
